import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { LiveSessionSettings } from 'redux/schemas/models/courseFull';
import t from 'react-translate';
import { AlertMessageType } from 'redux/schemas/app/alert-message';
import { LiveEventSession } from 'redux/schemas/models/live-event';
import { makeQueryParamString } from './helpers';
import { addAlertMessage } from './alert-messages';

export const getLiveSessionSettings = createAsyncThunk<LiveSessionSettings, { catalogId: string, userId?: number }>(
  'GET_LIVE_SESSION_SETTINGS',
  async (params: { catalogId: string, userId: number }) => {
    const query = makeQueryParamString({ userId: params.userId });
    const response = await axios.get(`${params.catalogId}/user_courses/live_session_settings.json?${query}`);
    return response.data.result;
  },
);

export const toggleSessionRegistration = createAsyncThunk<LiveEventSession, { catalogId: string, sessionId?: number, isRegister: boolean }>(
  'TOGGLE_SESSION_REGISTRATION',
  async (params, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.post(`${params.catalogId}/live_session/${params.sessionId}/register_session`, { register: params.isRegister });
      const message = params.isRegister
        ? t.LECTURE_PAGES.COMPONENTS.LIVE_VIDEO_EVENTS.REGISTRATION.SUCCESS_REGISTRATION()
        : t.LECTURE_PAGES.COMPONENTS.LIVE_VIDEO_EVENTS.REGISTRATION.UNREGISTER.SUCCESS();
      dispatch(addAlertMessage({
        type: AlertMessageType.SUCCESS,
        header: t.FORM.SUCCESS_BANG(),
        message,
      }));
      return response.data.result;
    } catch (error) {
      dispatch(addAlertMessage({
        type: AlertMessageType.ERROR,
        header: t.FORM.OOPS(),
        message: t.FORM.ERROR_SOMETHING_WRONG(),
      }));
      return rejectWithValue(error);
    }
  },
);
export const getRegisteredSessionDetails = createAsyncThunk<LiveEventSession, { catalogId: string, liveSessionId?: number }>(
  'GET_REGISTERED_SESSION_DETAILS',
  async (params) => {
    const response = await axios.get(`${params.catalogId}/live_session/${params.liveSessionId}/registered_session_details`);
    return response.data.result;
  },
);
